module.exports = __webpack_public_path__ + "static/desktop-404@2x-f79c60bb305f84f1310958d0ef133431.png";